/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GeoAssetDTO } from '../models/geo-asset-dto';
import { GeoAssetDetailDTO } from '../models/geo-asset-detail-dto';
import { GeoAssetDetailWithGeoJson } from '../models/geo-asset-detail-with-geo-json';
import { CreateGeoAssetRequest } from '../models/create-geo-asset-request';
import { UpdateGeoAssetRequest } from '../models/update-geo-asset-request';
import { GeoAssetTypeDTO } from '../models/geo-asset-type-dto';
import { CreateGeoAssetTypeRequest } from '../models/create-geo-asset-type-request';
import { UpdateGeoAssetTypeRequest } from '../models/update-geo-asset-type-request';
@Injectable({
  providedIn: 'root',
})
class GeoAssetService extends __BaseService {
  static readonly GeoAssetFindNearestCentroidPath = '/api/GeoAsset/findByCentroid/{customerId}/{latitude}/{longitude}';
  static readonly GeoAssetCheckPointInPolygonPath = '/api/GeoAsset/pointInPolygon/{customerId}/{latitude}/{longitude}';
  static readonly GeoAssetGetAssetsAsGeoJsonPath = '/api/GeoAsset/geojson/{customerId}';
  static readonly GeoAssetGetGeoAssetPath = '/api/GeoAsset/GetGeoAsset/{customerId}/{id}';
  static readonly GeoAssetGetAllGeoAssetsPath = '/api/GeoAsset/GetAllGeoAssets/{customerId}';
  static readonly GeoAssetGetAllGeoAssetsWithinBoundingBoxPath = '/api/GeoAsset/GetAllGeoAssetsWithinBoundingBox/{customerId}';
  static readonly GeoAssetGetGeoAssetGeometryPath = '/api/GeoAsset/GetGeoAssetGeometry/{customerId}/{id}';
  static readonly GeoAssetCreateGeoAssetPath = '/api/GeoAsset/CreateGeoAsset';
  static readonly GeoAssetUpdateGeoAssetPath = '/api/GeoAsset/UpdateGeoAsset/{customerId}/{id}';
  static readonly GeoAssetGetAllGeoAssetTypesPath = '/api/GeoAsset/types/{customerId}';
  static readonly GeoAssetGetGeoAssetTypePath = '/api/GeoAsset/types/{customerId}/{id}';
  static readonly GeoAssetCreateGeoAssetTypePath = '/api/GeoAsset/types/Create/{customerId}';
  static readonly GeoAssetUpdateGeoAssetTypePath = '/api/GeoAsset/types/Update/{customerId}/{id}';
  static readonly GeoAssetSearchPath = '/api/GeoAsset/Search/{customerId}/{type}/{searchSize}/{pageIndex}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `GeoAssetService.GeoAssetFindNearestCentroidParams` containing the following parameters:
   *
   * - `longitude`:
   *
   * - `latitude`:
   *
   * - `customerId`:
   */
  GeoAssetFindNearestCentroidResponse(params: GeoAssetService.GeoAssetFindNearestCentroidParams): __Observable<__StrictHttpResponse<GeoAssetDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/findByCentroid/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.latitude))}/${encodeURIComponent(String(params.longitude))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetFindNearestCentroidParams` containing the following parameters:
   *
   * - `longitude`:
   *
   * - `latitude`:
   *
   * - `customerId`:
   */
  GeoAssetFindNearestCentroid(params: GeoAssetService.GeoAssetFindNearestCentroidParams): __Observable<GeoAssetDTO> {
    return this.GeoAssetFindNearestCentroidResponse(params).pipe(
      __map(_r => _r.body as GeoAssetDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetCheckPointInPolygonParams` containing the following parameters:
   *
   * - `longitude`:
   *
   * - `latitude`:
   *
   * - `customerId`:
   */
  GeoAssetCheckPointInPolygonResponse(params: GeoAssetService.GeoAssetCheckPointInPolygonParams): __Observable<__StrictHttpResponse<GeoAssetDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/pointInPolygon/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.latitude))}/${encodeURIComponent(String(params.longitude))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetCheckPointInPolygonParams` containing the following parameters:
   *
   * - `longitude`:
   *
   * - `latitude`:
   *
   * - `customerId`:
   */
  GeoAssetCheckPointInPolygon(params: GeoAssetService.GeoAssetCheckPointInPolygonParams): __Observable<GeoAssetDTO> {
    return this.GeoAssetCheckPointInPolygonResponse(params).pipe(
      __map(_r => _r.body as GeoAssetDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetGetAssetsAsGeoJsonParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `n`:
   */
  GeoAssetGetAssetsAsGeoJsonResponse(params: GeoAssetService.GeoAssetGetAssetsAsGeoJsonParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.n || []).forEach(val => {if (val != null) __params = __params.append('n', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/geojson/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetGetAssetsAsGeoJsonParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `n`:
   */
  GeoAssetGetAssetsAsGeoJson(params: GeoAssetService.GeoAssetGetAssetsAsGeoJsonParams): __Observable<Blob> {
    return this.GeoAssetGetAssetsAsGeoJsonResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetGetGeoAssetParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetGetGeoAssetResponse(params: GeoAssetService.GeoAssetGetGeoAssetParams): __Observable<__StrictHttpResponse<GeoAssetDetailDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/GetGeoAsset/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetDetailDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetGetGeoAssetParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetGetGeoAsset(params: GeoAssetService.GeoAssetGetGeoAssetParams): __Observable<GeoAssetDetailDTO> {
    return this.GeoAssetGetGeoAssetResponse(params).pipe(
      __map(_r => _r.body as GeoAssetDetailDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetGetAllGeoAssetsParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `assetTypeId`:
   */
  GeoAssetGetAllGeoAssetsResponse(params: GeoAssetService.GeoAssetGetAllGeoAssetsParams): __Observable<__StrictHttpResponse<Array<GeoAssetDetailDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.assetTypeId != null) __params = __params.set('assetTypeId', params.assetTypeId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/GetAllGeoAssets/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GeoAssetDetailDTO>>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetGetAllGeoAssetsParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `assetTypeId`:
   */
  GeoAssetGetAllGeoAssets(params: GeoAssetService.GeoAssetGetAllGeoAssetsParams): __Observable<Array<GeoAssetDetailDTO>> {
    return this.GeoAssetGetAllGeoAssetsResponse(params).pipe(
      __map(_r => _r.body as Array<GeoAssetDetailDTO>)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetGetAllGeoAssetsWithinBoundingBoxParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `topLeftLon`:
   *
   * - `topLeftLat`:
   *
   * - `bottomRightLon`:
   *
   * - `bottomRightLat`:
   *
   * - `assetTypeId`:
   */
  GeoAssetGetAllGeoAssetsWithinBoundingBoxResponse(params: GeoAssetService.GeoAssetGetAllGeoAssetsWithinBoundingBoxParams): __Observable<__StrictHttpResponse<Array<GeoAssetDetailWithGeoJson>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.topLeftLon != null) __params = __params.set('topLeftLon', params.topLeftLon.toString());
    if (params.topLeftLat != null) __params = __params.set('topLeftLat', params.topLeftLat.toString());
    if (params.bottomRightLon != null) __params = __params.set('bottomRightLon', params.bottomRightLon.toString());
    if (params.bottomRightLat != null) __params = __params.set('bottomRightLat', params.bottomRightLat.toString());
    if (params.assetTypeId != null) __params = __params.set('assetTypeId', params.assetTypeId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/GetAllGeoAssetsWithinBoundingBox/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GeoAssetDetailWithGeoJson>>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetGetAllGeoAssetsWithinBoundingBoxParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `topLeftLon`:
   *
   * - `topLeftLat`:
   *
   * - `bottomRightLon`:
   *
   * - `bottomRightLat`:
   *
   * - `assetTypeId`:
   */
  GeoAssetGetAllGeoAssetsWithinBoundingBox(params: GeoAssetService.GeoAssetGetAllGeoAssetsWithinBoundingBoxParams): __Observable<Array<GeoAssetDetailWithGeoJson>> {
    return this.GeoAssetGetAllGeoAssetsWithinBoundingBoxResponse(params).pipe(
      __map(_r => _r.body as Array<GeoAssetDetailWithGeoJson>)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetGetGeoAssetGeometryParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetGetGeoAssetGeometryResponse(params: GeoAssetService.GeoAssetGetGeoAssetGeometryParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/GetGeoAssetGeometry/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetGetGeoAssetGeometryParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetGetGeoAssetGeometry(params: GeoAssetService.GeoAssetGetGeoAssetGeometryParams): __Observable<string> {
    return this.GeoAssetGetGeoAssetGeometryResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  GeoAssetCreateGeoAssetResponse(request: CreateGeoAssetRequest): __Observable<__StrictHttpResponse<GeoAssetDetailDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/GeoAsset/CreateGeoAsset`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetDetailDTO>;
      })
    );
  }
  /**
   * @param request undefined
   */
  GeoAssetCreateGeoAsset(request: CreateGeoAssetRequest): __Observable<GeoAssetDetailDTO> {
    return this.GeoAssetCreateGeoAssetResponse(request).pipe(
      __map(_r => _r.body as GeoAssetDetailDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetUpdateGeoAssetParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetUpdateGeoAssetResponse(params: GeoAssetService.GeoAssetUpdateGeoAssetParams): __Observable<__StrictHttpResponse<GeoAssetDetailDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/GeoAsset/UpdateGeoAsset/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetDetailDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetUpdateGeoAssetParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetUpdateGeoAsset(params: GeoAssetService.GeoAssetUpdateGeoAssetParams): __Observable<GeoAssetDetailDTO> {
    return this.GeoAssetUpdateGeoAssetResponse(params).pipe(
      __map(_r => _r.body as GeoAssetDetailDTO)
    );
  }

  /**
   * @param customerId undefined
   */
  GeoAssetGetAllGeoAssetTypesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<GeoAssetTypeDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/types/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GeoAssetTypeDTO>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  GeoAssetGetAllGeoAssetTypes(customerId: number): __Observable<Array<GeoAssetTypeDTO>> {
    return this.GeoAssetGetAllGeoAssetTypesResponse(customerId).pipe(
      __map(_r => _r.body as Array<GeoAssetTypeDTO>)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetGetGeoAssetTypeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetGetGeoAssetTypeResponse(params: GeoAssetService.GeoAssetGetGeoAssetTypeParams): __Observable<__StrictHttpResponse<GeoAssetTypeDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/types/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetTypeDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetGetGeoAssetTypeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetGetGeoAssetType(params: GeoAssetService.GeoAssetGetGeoAssetTypeParams): __Observable<GeoAssetTypeDTO> {
    return this.GeoAssetGetGeoAssetTypeResponse(params).pipe(
      __map(_r => _r.body as GeoAssetTypeDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetCreateGeoAssetTypeParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   */
  GeoAssetCreateGeoAssetTypeResponse(params: GeoAssetService.GeoAssetCreateGeoAssetTypeParams): __Observable<__StrictHttpResponse<GeoAssetTypeDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/GeoAsset/types/Create/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetTypeDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetCreateGeoAssetTypeParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   */
  GeoAssetCreateGeoAssetType(params: GeoAssetService.GeoAssetCreateGeoAssetTypeParams): __Observable<GeoAssetTypeDTO> {
    return this.GeoAssetCreateGeoAssetTypeResponse(params).pipe(
      __map(_r => _r.body as GeoAssetTypeDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetUpdateGeoAssetTypeParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetUpdateGeoAssetTypeResponse(params: GeoAssetService.GeoAssetUpdateGeoAssetTypeParams): __Observable<__StrictHttpResponse<GeoAssetTypeDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/GeoAsset/types/Update/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GeoAssetTypeDTO>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetUpdateGeoAssetTypeParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  GeoAssetUpdateGeoAssetType(params: GeoAssetService.GeoAssetUpdateGeoAssetTypeParams): __Observable<GeoAssetTypeDTO> {
    return this.GeoAssetUpdateGeoAssetTypeResponse(params).pipe(
      __map(_r => _r.body as GeoAssetTypeDTO)
    );
  }

  /**
   * @param params The `GeoAssetService.GeoAssetSearchParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `customerId`:
   *
   * - `sortOrder`:
   *
   * - `sortColumn`:
   *
   * - `search`:
   */
  GeoAssetSearchResponse(params: GeoAssetService.GeoAssetSearchParams): __Observable<__StrictHttpResponse<Array<GeoAssetDetailDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;




    if (params.sortOrder != null) __params = __params.set('sortOrder', params.sortOrder.toString());
    if (params.sortColumn != null) __params = __params.set('sortColumn', params.sortColumn.toString());
    if (params.search != null) __params = __params.set('search', params.search.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/GeoAsset/Search/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.type))}/${encodeURIComponent(String(params.searchSize))}/${encodeURIComponent(String(params.pageIndex))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GeoAssetDetailDTO>>;
      })
    );
  }
  /**
   * @param params The `GeoAssetService.GeoAssetSearchParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `customerId`:
   *
   * - `sortOrder`:
   *
   * - `sortColumn`:
   *
   * - `search`:
   */
  GeoAssetSearch(params: GeoAssetService.GeoAssetSearchParams): __Observable<Array<GeoAssetDetailDTO>> {
    return this.GeoAssetSearchResponse(params).pipe(
      __map(_r => _r.body as Array<GeoAssetDetailDTO>)
    );
  }
}

module GeoAssetService {

  /**
   * Parameters for GeoAssetFindNearestCentroid
   */
  export interface GeoAssetFindNearestCentroidParams {
    longitude: number;
    latitude: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetCheckPointInPolygon
   */
  export interface GeoAssetCheckPointInPolygonParams {
    longitude: number;
    latitude: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetGetAssetsAsGeoJson
   */
  export interface GeoAssetGetAssetsAsGeoJsonParams {
    customerId: number;
    n?: null | Array<string>;
  }

  /**
   * Parameters for GeoAssetGetGeoAsset
   */
  export interface GeoAssetGetGeoAssetParams {
    id: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetGetAllGeoAssets
   */
  export interface GeoAssetGetAllGeoAssetsParams {
    customerId: number;
    assetTypeId?: null | number;
  }

  /**
   * Parameters for GeoAssetGetAllGeoAssetsWithinBoundingBox
   */
  export interface GeoAssetGetAllGeoAssetsWithinBoundingBoxParams {
    customerId: number;
    topLeftLon?: number;
    topLeftLat?: number;
    bottomRightLon?: number;
    bottomRightLat?: number;
    assetTypeId?: null | number;
  }

  /**
   * Parameters for GeoAssetGetGeoAssetGeometry
   */
  export interface GeoAssetGetGeoAssetGeometryParams {
    id: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetUpdateGeoAsset
   */
  export interface GeoAssetUpdateGeoAssetParams {
    request: UpdateGeoAssetRequest;
    id: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetGetGeoAssetType
   */
  export interface GeoAssetGetGeoAssetTypeParams {
    id: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetCreateGeoAssetType
   */
  export interface GeoAssetCreateGeoAssetTypeParams {
    request: CreateGeoAssetTypeRequest;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetUpdateGeoAssetType
   */
  export interface GeoAssetUpdateGeoAssetTypeParams {
    request: UpdateGeoAssetTypeRequest;
    id: number;
    customerId: number;
  }

  /**
   * Parameters for GeoAssetSearch
   */
  export interface GeoAssetSearchParams {
    type: number;
    searchSize: number;
    pageIndex: number;
    customerId: number;
    sortOrder?: null | string;
    sortColumn?: null | string;
    search?: null | string;
  }
}

export { GeoAssetService }
